
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallet/mobile",
      function () {
        return require("private-next-pages/wallet/mobile/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallet/mobile"])
      });
    }
  